<sj-sidebar-menu *ngIf="isLoader" [appMain]="appMain"  [authorities]="authorities" [environment]="environment" [logo]="logo" [sidebarActive]="appMain.sidebarActive"
    (sidebarClick)="appMain.onSidebarClick($event)" [navItems]="navItems"  (sidebarMoseOver)="appMain.onSidebarMouseOver($event)"
    (sidebarMouseLeave)="appMain.onSidebarMouseLeave($event)" (toggleMenu)="appMain.onToggleMenu($event)">
</sj-sidebar-menu>
